/* eslint-disable react/no-danger */
/* eslint-disable consistent-return */
import { useTheme } from "@mui/material";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import ArrowDown from "../../../../public/assets/icons/ArrowDown";
import NoDataComponent from "../../common/components/NoData";
import { eventTracking } from "../../../firebase/firebaseConfig";
import { TTheme } from "../../../utils/configs/setupTheme";
import { commonActions } from "../../common/redux/actions";
import { TCommonState } from "../../common/utils/type";
import { ACCESS_LEVEL } from "../utils/contants";
import SubjectCard from "./SubjectCard";

const SubjectTabExamOrPractice = ({
  handleClickLink,
  handleSetHideItems,
  list,
  checkIsHideItem,
  location,
  isShowLock,
  handleOpenModalConfirmLogin,
  handleOpenModalConfirmPremium
}) => {
  const dispatch = useDispatch();
  const dataUser = useSelector((state: { commonNew: TCommonState }) => state.commonNew.userInfos);
  const theme: TTheme = useTheme();
  const onClickTopic = (ele) => {
    eventTracking("select_subject_item", {}, () => {
      dispatch(commonActions.handleDirectUrl(`/${location?.grade}/${location?.subjectsId}/de-thi/${ele.slug}`));
      if (typeof dataUser?.member?.pub_id !== "undefined") {
        if (ACCESS_LEVEL.PREMIUM.includes(ele?.access_level) && !isShowLock(ele?.access_level)) {
          handleOpenModalConfirmPremium();
        } else if (ele?.access_level === ACCESS_LEVEL.LOGIN && !isShowLock(ele?.access_level)) {
          handleOpenModalConfirmLogin();
        } else
        
          handleClickLink(
            `/${location?.grade}/${location?.subjectsId}/${list?.type === "practice" ? "bai-tap" : "de-thi"}/${
              ele.slug
            }`,
            ele?.access_level === ACCESS_LEVEL.NOT_LOGIN ? 0 : ele?.extra?.price,
            list?.type === "exam" && !ele?.num_of_times
          );
      } else if (!isShowLock(ele?.access_level)) {
        handleOpenModalConfirmLogin();
      } else {
        handleClickLink(
          `/${location?.grade}/${location?.subjectsId}/${list?.type === "practice" ? "bai-tap" : "de-thi"}/${ele.slug}`,
          ele?.access_level === ACCESS_LEVEL.NOT_LOGIN ? 0 : ele?.extra?.price,
          list?.type === "exam" && !ele?.num_of_times
        );
      }
    });
  };
  if (list?.items?.length === 0) {
    return <NoDataComponent />;
  }
  return list?.items?.map((element, index) => (
    <div key={index}>
      <button
        type="button"
        onClick={() => {
          handleSetHideItems(index);
        }}
        style={{
          color: "black",
          padding: 0,
          display: "flex",
          justifyContent: "space-between",
          width: "100%"
        }}
      >
        <span className="normal-case font-semibold text-[18px]" style={{ textAlign: "justify" }}>
          {element?.title}
        </span>
        <div
          style={{
            color: theme.palette.primary.gray400,
            transform: !checkIsHideItem(index) ? "rotate(-90deg)" : ""
          }}
        >
          <ArrowDown />
        </div>
      </button>
      {!checkIsHideItem(index) && (
        <>
          {element?.seo_data && (
            <span
              className="text-[13px] py-2 text-gray2"
              dangerouslySetInnerHTML={{ __html: element?.seo_data?.box_top }}
            />
          )}
          <div className="grid 2xl:grid-cols-2 sm:grid-cols-1 gap-4 gap-x-4 py-4">
            {element.items?.map((ele) => (
              <SubjectCard key={ele?.id} ele={ele} isShowLock={isShowLock} onClickTopic={onClickTopic} />
            ))}
          </div>
        </>
      )}
    </div>
  ));
};

export default SubjectTabExamOrPractice;
